import React, { useEffect, useState } from "react";
import { ChevronRight, Hospital, Star } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";

const fallbackClinics = [
  { name: "CityCare Clinic", eta: "10-15 min", area: "Downtown" },
  { name: "HealthPoint Medical Center", eta: "15-20 min", area: "West End" },
  { name: "Sunrise Family Clinic", eta: "20-25 min", area: "Uptown" },
];

export default function HomeNearbyClinics() {
  const navigate = useNavigate();
  const [clinics, setClinics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    api.get("/api/nearby-clinics?limit=12")
      .then((response) => {
        const data = Array.isArray(response?.data?.clinics)
          ? response.data.clinics
          : Array.isArray(response?.data)
            ? response.data
            : [];
        if (mounted) setClinics(data.length ? data : fallbackClinics);
      })
      .catch(() => {
        if (mounted) setClinics(fallbackClinics);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section style={{ marginTop: 16, marginBottom: 16 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
        <h4 style={{ margin: 0, fontWeight: 700, fontSize: 17, color: "#1f2937" }}>
          Nearby Clinics
        </h4>
        <button
          type="button"
          onClick={() => navigate("/doctor-consult")}
          style={{ border: "none", background: "transparent", color: "var(--primary)", fontWeight: 700, fontSize: 14, padding: 0, display: "inline-flex", alignItems: "center", gap: 2, cursor: "pointer" }}
        >
          See All <ChevronRight size={16} />
        </button>
      </div>

      {loading ? (
        <div style={{ display: "flex", gap: 10, overflowX: "hidden" }}>
          {[1, 2].map((item) => (
            <div key={item} style={{ minWidth: 320, height: 238, borderRadius: 18, background: "#e5e7eb" }} />
          ))}
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "row", gap: 10, overflowX: "auto", paddingBottom: 4, scrollSnapType: "x mandatory", scrollbarWidth: "none" }}>
          {clinics.map((clinic, index) => (
            <div
              key={clinic._id || `${clinic.name}-${index}`}
              onClick={() => clinic._id && navigate(`/clinic/${clinic._id}`, { state: clinic })}
              role={clinic._id ? "button" : undefined}
              tabIndex={clinic._id ? 0 : undefined}
              onKeyDown={(event) => {
                if (clinic._id && (event.key === "Enter" || event.key === " ")) {
                  navigate(`/clinic/${clinic._id}`, { state: clinic });
                }
              }}
              style={{ border: "1px solid #e9e8ef", borderRadius: 18, background: "var(--surface)", width: 320, flex: "0 0 320px", overflow: "hidden", boxShadow: "0 3px 10px rgba(0,0,0,0.12)", scrollSnapAlign: "start", cursor: clinic._id ? "pointer" : "default" }}
            >
              <div style={{ width: "100%", height: 178, overflow: "hidden" }}>
                {clinic.image || clinic.logo ? (
                  <img src={clinic.image || clinic.logo} alt={clinic.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                ) : (
                  <div style={{ width: "100%", height: "100%", background: "rgba(106,58,255,0.12)", display: "grid", placeItems: "center" }}>
                    <Hospital size={40} color="var(--primary)" />
                  </div>
                )}
              </div>
              <div style={{ background: "#efefef", padding: "12px 14px 14px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <div style={{ fontSize: 15, fontWeight: 700, color: "#202125", textAlign: "center", lineHeight: 1.2 }}>
                  {clinic.name || "Nearby Clinic"}
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 5, color: "#2a2b30", marginTop: 4 }}>
                  <Star size={12} fill="#FFD700" color="#FFD700" />
                  <span style={{ fontSize: 13, fontWeight: 700 }}>{clinic.rating || 4.5}</span>
                  <span style={{ fontSize: 13 }}>({clinic.reviews || 100})</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
